import type { ColumnType } from "antd/es/table";
import { useIntl } from "react-intl";
import { DeletePromotionRelegationRuleAction } from "~Features/EditSeason/components/PromotionRelegationRules/components/Action/DeletePromotionRelegationRuleAction.tsx";
import { EditPromotionRelegationRuleAction } from "~Features/EditSeason/components/PromotionRelegationRules/components/Action/EditPromotionRelegationRuleAction.tsx";
import type { PromotionRelegationRuleTableRow } from "~Features/EditSeason/components/PromotionRelegationRules/types/promotionRelegationRuleTableRow.ts";

export const useGetPromotionRelegationRuleColumns = (
  onDelete: (row: PromotionRelegationRuleTableRow) => Promise<void>,
  onSave: () => Promise<void>,
  loading: boolean,
) => {
  const { formatMessage } = useIntl();

  const columns: ColumnType<PromotionRelegationRuleTableRow>[] = [
    {
      title: formatMessage({ id: "promotion.relegation.rules.ruleType" }),
      dataIndex: "ruleType",
      key: "ruleType",
    },
    {
      title: formatMessage({ id: "promotion.relegation.rules.position" }),
      dataIndex: "position",
      key: "position",
    },
    {
      title: formatMessage({ id: "promotion.relegation.rules.value" }),
      dataIndex: "value",
      key: "value",
    },
    {
      fixed: "right",
      width: 20,
      render: (_: unknown, row: PromotionRelegationRuleTableRow) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <EditPromotionRelegationRuleAction row={row} onSave={onSave} loading={loading} />
          <DeletePromotionRelegationRuleAction onDelete={onDelete} record={row} />
        </div>
      ),
    },
  ];

  return columns;
};
